import React from 'react';

import { BrowserRouter } from 'react-router-dom';

const ReactRouterDomProvider: React.FC = ({ children }) => (
  <BrowserRouter>{children}</BrowserRouter>
);

export default ReactRouterDomProvider;
